/** First token of display name or email local-part (matches Today greeting). */
export function userFirstName(userOrAuth) {
  const user = userOrAuth?.user || userOrAuth;
  const dn = (user?.name || user?.display_name || user?.email || "").trim();
  return dn.split(/\s|@/)[0] || "there";
}

/** Possessive pronoun for persona intro copy (she/her → her, etc.). */
export function possessivePronoun(pronouns) {
  if (pronouns === "she/her") return "her";
  if (pronouns === "he/him") return "his";
  return "their";
}
